import CusInput from "./CusInput";

export default CusInput;
